import { useAuth } from "@/context/AuthContext";
import {Navigate} from "react-router-dom";
import {hasTattooActivity} from "@/serviceTypes";
import Projects from "@/pages/Projects";
import ArtistProjects from "@/pages/ArtistProjects";

export default function ProjectsEntry(){
  const { user, workspace }=useAuth();
  if(user?.role==="artist"&&!hasTattooActivity(workspace))return <Navigate to="/app/artist" replace/>;
  return user?.role==="artist"?<ArtistProjects/>:<Projects/>;
}

